var React = require('react');
var Select = require('react-select');

class Share  extends React.Component{
    getInititalState() {
        return { selectedUsers: '' };
    }
    handleChange=(type, e)=>{
        if (type == 'users') {
            if (type == null) {
                this.setState({
                    selectedUsers: null
                });
            }
            else
                this.setState({
                    selectedUsers: e
                });
        }
    }
    handleShare= (e)=>{
        e.preventDefault();        
        var url = window.location.pathname + window.location.search;
        var title = jQuery('#title').val();
        var comment = jQuery('#comment').val();
        var shareType = window.location.pathname.split('/');
        shareType = sharaType[2];
        jQuery.ajax({
            type: 'Get',
            url: '/dashboard/report/share',
            data: 'users=' + encodeURIComponent(this.state.selectedUsers) + '&url=' + encodeURIComponent(url) + '&title=' + title + '&comment=' + comment + '&shareType=' + sharaType,
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                var response = response.result;
                jQuery('#sharePopup').modal('toggle');
                if (response) {
                    _paq.push(['trackEvent', 'Share', shareType, title]);    
                    jQuery('#shareSuccess').show();
                    jQuery('#shareError').hide();
                } else {
                    jQuery('#shareSuccess').hide();
                    jQuery('#shareError').show();
                }
            }
        });
    }
    render () {
        var userList = this.props.users;
        var selectedUsers = this.state ? this.state.selectedUsers : null;
        return (
            <div>
                <div className='modal fade modal-wide' id='sharePopup' style={{ maxWidth: '400px', margin: '0px auto' }}>
                    <div className='modal-dialog'>
                        <div className='modal-content'>
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                                <h5 className='modal-title' id="alertData">Share</h5>
                            </div>
                            <div className="modal-body" style={{ width: "400px" }}>
                                <form autoComplete='off' className="form" style={{ marginBottom: '0px' }} method="post" onSubmit={this.handleShare}>
                                    <input name="authenticity_token" type="hidden" />
                                    <div className="form-group">
                                        <label htmlFor="users">Select Users</label>
                                        <Select simpleValue placeholder="Select Users"
                                            name="selectUsers"
                                            value={selectedUsers}
                                            onChange={this.handleChange.bind(this, 'users')}
                                            options={userList}
                                            multi={true}
                                        />
                                        <label htmlFor="title" style={{marginTop:'5px'}}>Subject</label>
                                        <input className="form-control" id="title" placeholder="Subject" type="text" style={{ width: "100%" }} />
                                        <label htmlFor="comment" style={{marginTop:'5px'}}>Comment</label>
                                        <textarea className='form-control'placeholder="Comment" rows='5' id='comment'></textarea>
                                    </div>
                                    <button className="btn btn-default marginStyle" data-dismiss="modal" id="popupClose" >Close</button>
                                    <button id="saveReportButton" className="btn btn-contrast marginStyle" type="submit">Done</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};
export default Share;